import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import DualListBox from "../../../duallistBox";
import Cookies from "js-cookie";
import { useUserPermissions } from "../../../UserPermissionsContext";
import CommonSelect from "../../../../core/common/commonSelect";
import Select from 'react-select'
import { Spin } from "antd";

type Permission = { id: number; name: string };

interface User {
    agent_group_type_id: number;
    agent_group_type_name: string;
  }

type Admin = {
  permissions: Array<number>;
  name: string | null;

  id: number;
};

interface Option {
    value: number;
    label: string;
  }

const EditAgentGroup = () => {
  const routes = all_routes;
  const navigate = useNavigate();
   const location = useLocation();
    const { id } = location.state || {};
  const [chosenPermissions, setChosenPermissions] = useState<Permission[]>([]);
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const [users, setUsers] = useState<User[]>([]);
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState<Option | null>(null);
    const [agentGroupName, setAgentGroupName] = useState<string>("");
  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };

  useEffect(() =>{
    console.log("selectedOption", selectedOption)
  },[selectedOption])

  const options1: Option[] = users.map(user => ({
    value: user.agent_group_type_id,
    label: user.agent_group_type_name,
  }));


  const handleChange = (option: Option | null) => {
    setSelectedOption(option);
    if (option) {
      console.log('Selected ID:', option.value);
    }
  };




  const handlePermissionsChange = (selected: Permission[]) => {
    setChosenPermissions(selected);
  };
  const [newAdmin, setNewAdmin] = useState<Admin>({
    name: null,
    id: 0,
    permissions: [],
  });

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchTeamData = async (id: string) => {
    const response = await fetch(`${webApi}/teammgmt/agent_groups/${id}`, options);
     if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === "token_not_valid") {
        navigate("/academic/sri-chaitanya/crm/landing-page");
      }
      throw new Error(errorData.detail || "Failed to fetch user data");
    }
    return await response.json();
  };

  const fetchPermissionsData = async () => {
    const resposne = await fetch(`${webApi}/user/users_dropdown/`, options);
    return await resposne.json();
  };

  const fetchGroupTypesData = async () => {
    const resposne = await fetch(`${webApi}/teammgmt/agent_group_types_dropdown/`, options);
    return await resposne.json();
  }

  const fetchData = async () => {
    setIsLoading(true); // Start loading
    try {
      const [permissionsData, teamData,groupTypesData] = await Promise.all([fetchPermissionsData(),fetchTeamData(id), fetchGroupTypesData()]);

      // Convert the fetched data to the Permission type
      const formattedPermissions = permissionsData.map(
        (permission: { id: number; username: string }): Permission => ({
          id: permission.id,
          name: permission.username,
        })
      );

      setPermissions(formattedPermissions);
      setUsers(groupTypesData);
      setAgentGroupName(teamData.agent_group_name);
      const options1 = groupTypesData.map((user: { agent_group_type_id: any; agent_group_type_name: any; }) => ({
        value: user.agent_group_type_id,
        label: user.agent_group_type_name,
      }));
      setSelectedOption(
        options1.find((option: { value: any; }) => option.value === teamData.agent_group_type) || null
      );
    setChosenPermissions(formattedPermissions.filter((permission: { id: any; }) => teamData.agents.includes(permission.id)));
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    if (!checkPermission("change_agentgroup", "agentgroup")) {
      navigate(routes.crmLandingPage);
    } else {
      fetchData();
    }
  }, [userPermissions]);

  const updateData = async () => {
    const newTeam = {
        agent_group_name: agentGroupName,
        agent_group_type: selectedOption ? selectedOption.value : null,
        agents: chosenPermissions.map(permission => permission.id),
      };
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(newTeam),
    };
    const url = `${webApi}/teammgmt/agent_groups/${id}/`;
    const response = await fetch(url, requestOptions);
    if (!response.ok) {
      const errorData = await response.json();

      throw new Error("Network response was not ok");
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await updateData();
      navigate(routes.agentGroupsList);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAgentGroupName(e.target.value);
  };

  useEffect(() => {
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const forms = document.querySelectorAll(
      ".needs-validation"
    ) as NodeListOf<HTMLFormElement>;

    // Loop over them and prevent submission
    Array.from(forms).forEach((form) => {
      form.addEventListener(
        "submit",
        (event) => {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }

          form.classList.add("was-validated");
        },
        false
      );
    });
  }, []);
  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Edit Agent Group</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={routes.agentGroupsList}>
                    Agent Group List
                    </Link>
                  </li>
                  <li className="breadcrumb-item active">Edit Agent Group</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}

          {/* Row */}
          <div className="row justify-content-center">
            <div className="col-sm-12 d-flex justify-content-center">
              {/* Add Group */}
              <div
                className="card"
                style={{
                  width: "70%",
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                  borderRadius: "10px",
                }}
              >
                <div className="card-body">
                {isLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    height: "100vh",
                    paddingTop: "20px",
                  }}
                >
                  <Spin /> {/* Display loader while loading */}
                </div>
              ) : (
                  <form onSubmit={handleSubmit}>
                    <div
                      className="form-group mb-3"
                      style={{
                        width: "70%",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ width: "48%" }}>
                        <label className="form-label">Agent Group Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="agent_group_name"
                          placeholder="Agent Group Name"
                          onChange={handleInputChange}
                          value={agentGroupName}
                          required
                        />
                      </div>
                      <div style={{ width: "48%" }}>
                        <label className="form-label">Agent Group Type Name</label>
                        <Select
                          value={selectedOption}
                          onChange={handleChange}
                          options={options1}
                          placeholder="Select a Agent Group Type"
                        />
                      </div>
                    </div>

                    <div className="form-group dual-list-box-container">
                      <label className="form-label">Permissions</label>
                      <DualListBox
                        options={permissions}
                        selected={chosenPermissions}
                        onChange={handlePermissionsChange}
                      />
                    </div>
                    <div className="modal-footer">
                      <Link
                        className="btn btn-primary"
                        type="submit"
                        to={routes.agentGroupsList}
                        style={{
                          backgroundColor: "lightcoral",
                          color: "white",
                          marginRight: "5px",
                        }}
                      >
                        Cancel
                      </Link>
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <i className="spinner-border spinner-border-sm"></i>
                        ) : (
                          <>Save</>
                        )}
                      </button>
                    </div>
                  </form>
              )}
                </div>
              </div>
              {/* /Add Group */}
            </div>
          </div>
          {/* /Row */}
        </div>
      </div>
    </div>
  );
};

export default EditAgentGroup;
